import { LifeBuoy, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Indicatore discreto visibile solo al superadmin durante la sessione di assistenza.
export const ImpersonationBar = () => {
  const { user, logout } = useAuth();
  if (!user?.impersonating) return null;
  return (
    <div className="fixed bottom-3 right-3 z-[90] flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/90 px-3 py-1.5 text-xs text-slate-300 shadow-lg backdrop-blur" data-testid="impersonation-bar">
      <LifeBuoy className="h-3.5 w-3.5 text-amber-400" />
      <span data-testid="impersonation-studio" style={{ color: "#e2e8f0" }}>Assistenza: {user.imp_studio}</span>
      <button type="button" onClick={logout} data-testid="impersonation-exit"
        className="ml-1 inline-flex items-center gap-1 rounded-full bg-amber-500 px-2.5 py-0.5 font-semibold text-[#0a0d14] transition-colors hover:bg-amber-400">
        <LogOut className="h-3 w-3" /> Torna al pannello
      </button>
    </div>
  );
};
